export const SESSION_OPEN = 'open';
export const SESSION_CLOSED = 'closed';
export const SESSION_READY = 'ready';
export const SESSION_ON_DEMAND = 'on-demand';
export const SESSION_MEGA = 'mega';
export const SESSION_ERROR = 'error';
export const SESSION_REPLAY = 'replay';
